<template>
    <div class="toastlink-container" v-bind:class="{'width-container':loc, 'visible':loc && visible, 'rightvisible':(loc=='right') && visible, 'centervisible':(loc=='center') && visible}">
        <div class="pin"></div>
        <div v-if="loc" class="arrow"></div>
        <div class="toastcol">
            <span class="icon-animate" v-if="loc">
                <i :class="iconClass" v-show="!!iconClass" />
            </span>
            <div :class="{'loc-padding': loc}">
                <div v-if="title" class="title">{{title}}</div>
                <div class="message">{{message}}</div>
            </div>
            <button type="button" class="dismiss" v-if="loc" @click="hide()">Dismiss</button>
        </div>
    </div>
</template>

<script src="./mvt-toastlinked.js"></script>

<style lang="scss">
@use "./mvt-toastlinked.scss" as *;
</style>